import gql from 'graphql-tag';
import { HumidityIcon } from '~components/ui/icons';
import { IconBadge, Props as IconBadgeProps } from '~components/ui/icons/IconBadge';
import { HumidityBadge_DisplayFragment } from './__generated__/HumidityBadge.graphql';

export default function HumidityBadge({
  variant,
}: {
  display: HumidityBadge_DisplayFragment;
} & Pick<IconBadgeProps, 'variant'>) {
  return (
    <IconBadge
      bg="blue.50"
      color="blue.50"
      icon={HumidityIcon}
      tooltip={undefined}
      variant={variant}
    />
  );
}

HumidityBadge.graphql = {
  fragments: {
    HumidityBadge_display: gql`
      fragment HumidityBadge_display on Display {
        id
        humidity {
          isSensorPresent
          value
          updatedAt
        }
      }
    `,
  },
};
